import { notification } from 'antd';

import apiNetCore from '../services/apiNetCore';

export const carregaCidades = async (
  cidadeNome,
  setCidades,
  setCarregandoCidades
) => {
  setCidades([]);
  if (cidadeNome && cidadeNome.length >= 3) {
    try {
      setCarregandoCidades(true);
      const response = await apiNetCore.get('/CidadeAts/GetCidadeCotacao', {
        params: { cidadeNome },
      });
      setCidades(response.data);
    } catch (err) {
      notification.error({
        message: 'Ops, não conseguimos buscar as cidades',
        description: 'Se o problema persistir, entre em contato com o suporte',
      });
    } finally {
      setCarregandoCidades(false);
    }
  }
};

export const carregaCidadesPorId = async (
  idCidade,
  setCidades,
  setCarregandoCidades
) => {
  setCidades([]);
  if (idCidade) {
    try {
      setCarregandoCidades(true);
      const response = await apiNetCore.get('/CidadeAts/ConsultarPorId', {
        params: { idCidade },
      });

      const cidade = {
        cidadeNome: response.data.data.Nome || null,
        ibge: response.data.data.IBGE || null,
        idCidade: response.data.data.IdCidade || null,
        idEstado: response.data.data.IdEstado || null,
        sigla: response.data.data.Sigla || null,
      };

      setCidades([cidade]);
    } catch (err) {
      notification.error({
        message: 'Ops, não conseguimos buscar as cidades',
        description: 'Se o problema persistir, entre em contato com o suporte',
      });
    } finally {
      setCarregandoCidades(false);
    }
  }
};
